import { useEffect, useRef } from 'react';
import { useForm } from 'react-final-form';

export const usePauseValidator = () => {
  const isMounted = useRef(false);
  const { pauseValidation, resumeValidation } = useForm();

  if (!isMounted.current) {
    pauseValidation();
    isMounted.current = true;
  }

  useEffect(() => resumeValidation(), [resumeValidation]);
};
